import React from 'react'
import Can from 'components/Can'
import { Col, Row } from 'react-bootstrap'
import * as quote from 'images/iconesIntelisys/quote_assistant.png'
import * as order from 'images/iconesIntelisys/order_assistant.png'
import * as comission from 'images/iconesIntelisys/commission_inquiry.png'
import * as supplier from 'images/iconesIntelisys/supplier_info.png'
import * as logoST from 'images/iconesIntelisys/request_escalation.png'
import CardItem from './CardItem'

export default function SectionMasterAgent() {
  const items = [
    {
      permission: 'presales.index',
      path: '/master-agent/my-quotes',
      icon: quote,
      title: 'Pré Vendas'
    },
    {
      permission: 'postsales.index',
      path: '/master-agent/after-sales',
      icon: order,
      title: 'Pós Vendas'
    },
    {
      permission: 'comissions.index',
      path: '/master-agent/my-comissions',
      icon: comission,
      title: 'Comissões'
    },
    {
      permission: 'providers.index',
      path: '/master-agent/providers',
      icon: supplier,
      title: 'Fornecedores'
    },
    {
      permission: 'technical_support.index',
      path: '/master-agent/technical-support',
      icon: logoST,
      title: 'Suporte Técnico'
    },
    {
      permission: '',
      path: '/master-agent/technical-postsales',
      icon: logoST,
      title: 'Suporte Pós Venda'
    },
  ]
  return (<>
    <Col className="mt-4" sm="12" md="12" lg="12">
      <h6>Master Agent</h6>
    </Col>
    <Row>
      {items.map((item, idx) => {
        return (<>
          {item.permission ? (
            <Can do={item.permission} on="App" key={idx}>
              <CardItem item={item} />
            </Can>
          ) : (
            <CardItem key={idx} item={item} />
          )}
        </>)        
      })}      
    </Row>
  </>)
}